import React, { useEffect } from "react";
import { Form, Row, Col, Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

/* ===== LOVs ===== */
const yesNoLOV = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export default function LifecycleEventControlsForm({
  form,
  initialValues,
  onFinish,
  maturityEventOptions,
}) {
  useEffect(() => {
    if (initialValues) form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <>
      <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
        Lifecycle & Event Controls
      </h3>

      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row gutter={24}>
          {/* Early Sale Allowed */}
          <Col span={12}>
            <Form.Item
              name="earlySaleAllowed"
              label={
                <span>
                  Early Sale Allowed
                  <Tooltip title="Controls whether the system allows secondary market sale before maturity.">
                    <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                  </Tooltip>
                </span>
              }
              rules={[{ required: true }]}
            >
              <Select options={yesNoLOV} placeholder="Yes / No" style={{ height: 44 }} />
            </Form.Item>
          </Col>

          {/* Rollover Allowed */}
          <Col span={12}>
            <Form.Item
              name="rolloverAllowed"
              label={
                <span>
                  Rollover Allowed
                  <Tooltip title="Enables or disables automatic rollover processing at maturity.">
                    <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                  </Tooltip>
                </span>
              }
              rules={[{ required: true }]}
            >
              <Select options={yesNoLOV} placeholder="Yes / No" style={{ height: 44 }} />
            </Form.Item>
          </Col>

          {/* Auto Maturity */}
          <Col span={12}>
            <Form.Item
              name="autoMaturityFlag"
              label={
                <span>
                  Auto Maturity
                  <Tooltip title="Controls whether maturity events are processed automatically by batch.">
                    <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                  </Tooltip>
                </span>
              }
              rules={[{ required: true }]}
            >
              <Select options={yesNoLOV} placeholder="Yes / No" style={{ height: 44 }} />
            </Form.Item>
          </Col>

          {/* Maturity Event Code */}
          <Col span={12}>
            <Form.Item
              name="maturityEventCode"
              label={
                <span>
                  Maturity Event Action
                  <Tooltip title="Defines the system action executed at maturity.">
                    <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                  </Tooltip>
                </span>
              }
              rules={[{ required: true }]}
            >
              <Select options={maturityEventOptions} placeholder="Redeem / Rollover" style={{ height: 44 }} />
            </Form.Item>
          </Col>

          {/* Penalty Applicable */}
          <Col span={12}>
            <Form.Item
              name="penaltyApplicableFlag"
              label={
                <span>
                  Penalty Applicable
                  <Tooltip title="Determines whether penalties are calculated for early break or rollover.">
                    <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                  </Tooltip>
                </span>
              }
            >
              <Select options={yesNoLOV} placeholder="Yes / No" style={{ height: 44 }} />
            </Form.Item>
          </Col>
        </Row>

        <button type="submit" hidden />
      </Form>
    </>
  );
}
